export const isShiftEqual = (a, b) => {
  return (
    a.day === b.day && a.endTime === b.endTime && a.startTime === b.startTime
  );
};

export const hasShift = (arr, shift) => {
  return arr.find((a) => isShiftEqual(a, shift)) != null;
};

export const removeShift = (arr, shift) => {
  return arr.filter((a) => !isShiftEqual(a, shift));
};
